import {
	editorPageEvents,
	previewPageEvents,
	userManagementPageEvents,
	widgetListingPageEvents,
	configureWidgetPageEvents,
	configureFiltersPageEvents,
	themeSettingsPageEvents,
	anyPageEvents,
	previewNPublishPageEvents,
	reportSchedulerPageEvents,
	dasdboardDownloadEvents,
	widgetLoadTimeEvents,
	publicDashboardEvents
} from "./eventConstants";

import { logThisEvent, amplitudeEventParams as params } from "./amplitudeService";

const loggingTemplate = (name, origin, additionalParams = {}) => {
	params["uiScreen"] = origin;
	logThisEvent(name, { ...params, ...additionalParams });
};

const prepareEventsObj = (eventsArr, origin) => {
	return eventsArr.reduce(
		(obj, eventName) => (
			(obj[eventName] = (additionalParams, computedOrigin = "") =>
				loggingTemplate(eventName, origin || computedOrigin, additionalParams)),
			obj
		),
		{}
	);
};

export const logEditorPageEvents = prepareEventsObj(editorPageEvents, "editor");

export const logPreviewPageEvents = prepareEventsObj(previewPageEvents, "preview");

export const logUserManagementPageEvents = prepareEventsObj(userManagementPageEvents, "userManagement");

export const logWidgetListingPageEvents = prepareEventsObj(widgetListingPageEvents, "widgetListing");

export const logConfigureWidgetPageEvents = prepareEventsObj(configureWidgetPageEvents, "configureWidget");

export const logConfigureFiltersPageEvents = prepareEventsObj(configureFiltersPageEvents, "configureFilters");

export const logThemeSettingsPageEvents = prepareEventsObj(themeSettingsPageEvents, "themeSettings");

export const logAnyPageEvents = prepareEventsObj(anyPageEvents, "");

export const logPreviewNPublishPageEvents = prepareEventsObj(previewNPublishPageEvents, "previewNpublish");

export const logReportSchedulerEvents = prepareEventsObj(reportSchedulerPageEvents, "reportScheduler");

export const logDashboardDownloadEvents = prepareEventsObj(dasdboardDownloadEvents, "dashboardDownload");

export const logComponentLoadTimeEvents = prepareEventsObj(widgetLoadTimeEvents, "componentLoadTime");

export const logPublicDashboardLinkEvents = prepareEventsObj(publicDashboardEvents, "publicDashboardLinks");
